import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ItemLocationWithEventAccountFragmentDoc } from '../fragments/itemLocationWithEventAccount.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FindLocationQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type FindLocationQuery = { __typename?: 'Query', itemLocation: { __typename?: 'ItemLocation', id: string, name: string, type?: string | null, disabled_at?: string | null, delivery_address?: { __typename?: 'IdName', id: string, name: string } | null, event_account?: { __typename?: 'EventAccount', id: string, name?: string | null } | null, event?: { __typename?: 'EventReduced', id?: string | null, name?: string | null } | null } };


export const FindLocationDocument = gql`
    query FindLocation($id: ID!) {
  itemLocation(id: $id) {
    ...ItemLocationWithEventAccount
  }
}
    ${ItemLocationWithEventAccountFragmentDoc}`;

/**
 * __useFindLocationQuery__
 *
 * To run a query within a React component, call `useFindLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindLocationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindLocationQuery(baseOptions: Apollo.QueryHookOptions<FindLocationQuery, FindLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindLocationQuery, FindLocationQueryVariables>(FindLocationDocument, options);
      }
export function useFindLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindLocationQuery, FindLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindLocationQuery, FindLocationQueryVariables>(FindLocationDocument, options);
        }
export type FindLocationQueryHookResult = ReturnType<typeof useFindLocationQuery>;
export type FindLocationLazyQueryHookResult = ReturnType<typeof useFindLocationLazyQuery>;
export type FindLocationQueryResult = Apollo.QueryResult<FindLocationQuery, FindLocationQueryVariables>;